import component from './create.vue'

export default component
